import React from "react";
import _ from "lodash";

import QueryBuilderInput from "@/components/fields/query-builder";

export interface SearchBarProps {
  defaultValue: string | undefined;
  handleSearch: (query: string, queryBy?: string) => void;
  suggestions: { id: string; label: string }[];
}
export const SearchBar = ({
  handleSearch,
  defaultValue,
  suggestions,
}: SearchBarProps) => {
  return (
    // <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
    // <Input
    //   ref={ref}
    //   defaultValue={defaultValue}
    //   onChange={debounce((e: any) => onChange(e.target.value))}
    //   type="search"
    //   placeholder={placeholder}
    //   className="flex appearance-none bg-background pl-8 shadow-none w-[150px] lg:w-[400px] rounded-md"
    // />
    <div className="relative">
      <QueryBuilderInput
        onSearch={handleSearch}
        defaultValue={defaultValue}
        suggestions={suggestions}
      />
    </div>
  );
};
